import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomTable from '@/product/components/molecules/CustomTable'

import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { handleRedirectInternal } from '../../custom/common/components'
import { useHistory } from 'react-router-dom'
import SettingContext from '@/product/context/setting/settingContext'

const Review = (props) => {
    const reportContext = useContext(ReportContext)
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()
    let action = props.match.params.action

    const {
        searchTableAction,
        searchTable,
        table_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = useContext(SettingContext)

    const [tableBody, setTableBody] = useState([])
    const [data, setData] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            count: 1,
            order: '',
            orderby: 'ur.id,desc',
            table: 'user_review',
            filters: {
                fields: {
                    value:
                        action == 'all' ? '' : action == 'active' ? '1' : '0',
                    type: 'in',
                    field: 'ur.active',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
            ],
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTable(values)
        },
    })
    useEffect(() => {
        if (responseStatusSetting) {
            setIsLoading(false)
        }
    }, [responseStatusSetting])
    useEffect(() => {
        setIsLoading(true)
        formik.values.filters.fields.value =
            action == 'all' ? '' : action == 'active' ? '1' : '0'
        searchTable(formik.values, 'getReview')
    }, [action])

    useEffect(() => {
        if (table_data) {
            if (table_data && table_data.records.length) {
                setTableBody(table_data.records)
                setData(table_data)
                setIsLoading(false)
            }
        } else {
            setIsLoading(false)
        }
    }, [table_data])
    const onClickEdit = (id, action) => {
        setIsLoading(true)
        let val = tableBody.filter((e) => e.id == id)[0]
        if (action == 'active') val.active = 1
        else val.active = 0
        val.table = 'user_review'
        searchTableAction(val)
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'description',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Review',
        },
        {
            field: 'rating',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Rating',
        },
        {
            field: 'users_first_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User First Name',
        },
        {
            field: 'active',
            sort: true,
            firstChild: false,
            disablePadding: false,
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'active',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Inactive',
                },
            },
            type: 'condition',
            label: 'Status',
        },
    ]

    const tableActions = [
        {
            label: 'Move to Active',
            icon: <span className="material-icons">add_task</span>,
            onclick: onClickEdit,
            type: 'active',
        },
        {
            label: 'Move to Inactive',
            icon: <span className="material-icons">block</span>,
            onclick: onClickEdit,
            type: 'inactive',
        },
    ]
    return (
        <Layout>
            <div className="dashboard invoice">
                {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                <div className="d-flex justify-content-end">
                    <Button
                        id="invoice_report"
                        onClick={() =>
                            getAllExportDownload({
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `${action}_invoice_management`,
                            })
                        }
                    >
                        <span className="material-icons">get_app</span>Export
                        All Data
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTable}
                />
            </div>
        </Layout>
    )
}

export default Review
